
import { Toaster } from "@/components/ui/toaster";
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import CareerChatBot from '@/components/CareerChatBot';
import { Card } from "@/components/ui/card";
import { FileText, Briefcase, Linkedin, GraduationCap, Shield } from "lucide-react";

const CareerChat = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      
      <main className="container mx-auto px-4 pt-20 pb-8">
        <div className="text-center mb-8 mt-8">
          <h1 className="text-3xl md:text-4xl font-bold mb-2">AI Career Agent</h1>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Chat with your personal AI Career Agent to discover future-proof career paths 
            and get personalized guidance based on your unique profile.
          </p>
        </div>
        
        <CareerChatBot />
        
        <div className="max-w-4xl mx-auto mt-20">
          <h2 className="text-2xl font-bold mb-6 text-center">How Your AI Career Agent Can Help</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <Card className="p-6 flex flex-col items-center text-center">
              <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center mb-4">
                <FileText className="h-6 w-6 text-primary" />
              </div>
              <h3 className="text-lg font-medium mb-2">Resume Analysis</h3>
              <p className="text-sm text-muted-foreground">
                Let your AI Agent review your resume and provide actionable feedback to enhance your job prospects.
              </p>
            </Card>
            
            <Card className="p-6 flex flex-col items-center text-center">
              <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center mb-4">
                <Shield className="h-6 w-6 text-primary" />
              </div>
              <h3 className="text-lg font-medium mb-2">Future-Proof Career Paths</h3>
              <p className="text-sm text-muted-foreground">
                Discover AI-resistant careers and skills that will remain valuable in the evolving job market.
              </p>
            </Card>
            
            <Card className="p-6 flex flex-col items-center text-center">
              <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center mb-4">
                <Briefcase className="h-6 w-6 text-primary" />
              </div>
              <h3 className="text-lg font-medium mb-2">Skills Gap Analysis</h3>
              <p className="text-sm text-muted-foreground">
                Your AI Agent will identify missing in-demand skills and suggest personalized learning paths.
              </p>
            </Card>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
            <Card className="p-6 flex flex-col items-center text-center">
              <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center mb-4">
                <Linkedin className="h-6 w-6 text-primary" />
              </div>
              <h3 className="text-lg font-medium mb-2">LinkedIn Optimization</h3>
              <p className="text-sm text-muted-foreground">
                Have your AI Agent analyze your LinkedIn profile and suggest improvements to attract recruiters.
              </p>
            </Card>
            
            <Card className="p-6 flex flex-col items-center text-center">
              <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center mb-4">
                <GraduationCap className="h-6 w-6 text-primary" />
              </div>
              <h3 className="text-lg font-medium mb-2">Educational Guidance</h3>
              <p className="text-sm text-muted-foreground">
                Students can get AI-powered recommendations for universities and degrees aligned with future career trends.
              </p>
            </Card>
          </div>
        </div>
      </main>
      
      <Footer />
      <Toaster />
    </div>
  );
};

export default CareerChat;
